export default {
    ACCEPT_OFFER: "acceptOffer",
    CHANGE_CREDIT_LIMIT: "changeCreditLimit",
    INIT_CREDIT_LIMIT_CHANGE: "initCreditLimitChange",
    INIT_APPLY: "initApply",
    PATCH: "patch",
    RESTART_FLOW: "restartFlow",
    RESUME: "resume",
    RESUME_CASCADE_ACTION: "resume_cascade_action",
    SELECT_PAYMENT_PLAN: "selectPaymentPlan",
    START_FLOW: "startFlow",
    SUBMIT_BANK_CARD: "submitBankCard",
    SUBMIT_ANSWERS: "submitAnswers",
    SUBMIT_FULL_APPlY: "submitFullApply",
    SUBMIT_PREQUALIFLY: "submitPrequalify",
    SUBMIT_PRESCREEN: "submitPrescreen",
    SUBMIT_ESIGN: "submitEsign",
    SUBMIT_COMPLETE: "submitComplete",
    FINISH_APPLY: "finishApply",
    SUBMIT_BANK_ACCOUNT: "submitBankAccount",
    PROVE_SEND_SMS: "proveSendSms",
    PROVE_RESEND_SMS: "proveResendSms",
    PROVE_SMS_STATUS: "proveSmsStatus",
    PROVE_VERIFICATION_RESULT: "proveVerificationResult",
    RESOLVE_PAY_MONTHLY_ROUTE: "resolvePayMonthlyRoute",
}
